import {CommonModule} from '@angular/common';
import {NgModule, ModuleWithProviders} from '@angular/core';
import {LaNavSidebarComponent} from './la-nav-sidebar.component';

// Export module's public API

@NgModule({
  imports: [
    CommonModule,
  ],
  exports: [LaNavSidebarComponent],
  declarations: [LaNavSidebarComponent],
  providers: []
})
export class LaNavSidebarModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaNavSidebarModule,
      providers: []
    };
  }
}
